webpackJsonp([256871573202158],{

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Example = __webpack_require__(33);
	
	var _Example2 = _interopRequireDefault(_Example);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Example2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Purpose'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Because docs are only useful to a point, and then you need to some working code to better understand.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Lore has some examples ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/tree/master/examples' },
	        'in its source code'
	      ),
	      '. If there is a specific example you\'d like to see that doesn\'t exist, feel free to ',
	      _react2.default.createElement(
	        'a',
	        { href: 'https://github.com/lore/lore/issues' },
	        'create an issue to suggest it'
	      ),
	      '.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-examples-index-js-c5c842a12abc619aa7bb.js